import { render, staticRenderFns } from "./some-handle.vue?vue&type=template&id=08c3cdfd&scoped=true&"
import script from "./some-handle.vue?vue&type=script&lang=js&"
export * from "./some-handle.vue?vue&type=script&lang=js&"
import style0 from "./some-handle.vue?vue&type=style&index=0&id=08c3cdfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c3cdfd",
  null
  
)

export default component.exports